export default {
    methods: {
        mixCurrencyMask: function(value, maxLength) {
            value = String(value)
            let mask = '####'

            if (value.length > 3) {
                let counter = 0
                for (let i = 3; i < value.length; i++) {
                    if (counter == 0) mask = '.' + mask
                    counter++
                    mask = '#' + mask
                    if (counter > 2) counter = 0
                }
            }
            if (value.length == maxLength)
                mask = mask.substring(0, mask.length - 1)
            return '$' + mask
        },
    },
    filters: {
        mixFormatCurrency: function(value) {
            if (value == 0) return '$ ' + value
            if (!value || isNaN(value)) return
            const formatter = new Intl.NumberFormat('es')
            return '$ ' + formatter.format(value)
        },
    },
}
